import type { ReactNode } from 'react'

import { useIntersectionObserver } from 'usehooks-ts'

import {
  TabContentFooterStyled,
  type ITabContentFooterStyledProps,
} from './styles/TabContentFooterStyled'

interface ITabContentFooterProps extends ITabContentFooterStyledProps {
  children: ReactNode
}

export const TabContentFooter = ({
  children,
  isSticky,
}: ITabContentFooterProps) => {
  const { isIntersecting: isFooterAtBottom, ref } = useIntersectionObserver()

  return (
    <>
      <TabContentFooterStyled
        isSticky={isSticky}
        isFloating={isSticky && !isFooterAtBottom}
      >
        {children}
      </TabContentFooterStyled>
      {isSticky ? (
        <div ref={ref} data-testid='tab-content-footer-sentinel' />
      ) : null}
    </>
  )
}
